const measurementID = 'G-8YR4MFVWC9'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

let initialized = false

export function initializeGoogleTag(): void {
  if (initialized || typeof window === 'undefined') return

  initialized = true
  window.dataLayer ??= []
  window.gtag ??= (...args: unknown[]) => {
    window.dataLayer?.push(args)
  }

  window.gtag('js', new Date())
  window.gtag('config', measurementID, {send_page_view: false})

  if (document.querySelector(`script[data-google-tag="${measurementID}"]`) !== null) return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementID}`
  script.dataset.googleTag = measurementID
  document.head.append(script)
}
